import { useState } from "react";
import { X } from "lucide-react"; // Import close icon
import MasterPlanImage2D from "../assets/MasterPlan2D.png";
import MasterPlanImage3D from "../assets/MasterPlan3D.png";
import { useLanguage } from "../LanguageContext";
import { translations } from "../translations";

// Image Loader Component
const ImageLoader = ({ src, alt, className }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="relative w-full">
      {!loaded && (
        <div className="absolute inset-0 flex justify-center items-center bg-gray-100">
          <div className="w-8 h-8 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`${className} ${
          loaded ? "opacity-100" : "opacity-0"
        } transition-opacity duration-300`}
        loading="lazy"
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default function MasterPlan() {
  const { language } = useLanguage();

  const [selectedImage, setSelectedImage] = useState(null);

  const closeModal = () => setSelectedImage(null);

  return (
    <section>
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-12 text-center text-gray-900">
        {translations[language].MasterPlan}
      </h2>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 px-4 sm:px-8 md:px-12 lg:px-20">
        {/* First Image Block */}
        <div className="flex flex-col items-center">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4">
            {translations[language].TwoDMP}
          </h3>
          <button onClick={() => setSelectedImage(MasterPlanImage2D)}>
            <ImageLoader
              src={MasterPlanImage2D}
              alt="2D Master Plan"
              className="w-full max-w-4xl rounded-lg shadow-lg h-64 md:h-80 lg:h-96 object-cover"
            />
          </button>
        </div>

        {/* Second Image Block */}
        <div className="flex flex-col items-center">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-4">
            {translations[language].ThreeDMP}
          </h3>
          <button onClick={() => setSelectedImage(MasterPlanImage3D)}>
            <ImageLoader
              src={MasterPlanImage3D}
              alt="3D Master Plan"
              className="w-full max-w-4xl rounded-lg shadow-lg h-64 md:h-80 lg:h-96 object-cover"
            />
          </button>
        </div>
      </div>

      {/* Modal for Fullscreen Image Preview */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
          onClick={closeModal}
        >
          <div
            className="relative w-full max-w-6xl max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute -top-12 right-0 text-white hover:text-gray-300 transition-colors z-50"
              onClick={closeModal}
            >
              <X className="w-6 h-6 mt-5" />
            </button>
            {/* Fullscreen Image */}
            <img
              src={selectedImage}
              alt="Fullscreen Preview"
              className="w-full h-full max-h-[90vh] object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </section>
  );
}
